/*
 * @Author: DQL
 * @Date: 2020-03-18 09:56:04
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:12:43
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

// 获取机构树
export const deptTree = (params) => { return axios.get(`${commontCtx}/dept/tree/async`, { params: params }); };

export const deptRoleService = {

  getByRoleCode: (roleCode) => { return axios.get(`${commontCtx}/deptRole/role/${roleCode}`); },

  saveByRoleCode: (fd) => { return axios.post(`${commontCtx}/deptRole/role/save`, fd); },

  getByDeptCode: (roleCode) => { return axios.get(`${commontCtx}/deptRole/dept/${roleCode}`); },

  saveByDeptCode: (fd) => { return axios.post(`${commontCtx}/deptRole/dept/save`, fd); }
};

export const roleService = {
  queryRole: (params) => { return axios.get(`${commontCtx}/role/query`, { params: params }); },

  listRole: (params) => { return axios.get(`${commontCtx}/role/list`, { params: params }); },

  getRole: (roleCode) => { return axios.get(`${commontCtx}/role/get/${roleCode}`); },

  addRole: (fd) => { return axios.post(`${commontCtx}/role/save`, fd); },

  updateRole: (fd) => { return axios.put(`${commontCtx}/role/update`, fd); },

  deleteRole: (roleCode) => { return axios.delete(`${commontCtx}/role/delete/${roleCode}`); }
};
